import { makeStyles } from 'tss-react/mui'
import React from 'react'

const useStyles = makeStyles()((theme) => ({
  infoBox: {
    background: theme.brand.colors.clean,
    padding: theme.spacing(4),
    borderRadius: theme.spacing(1),
    marginLeft: theme.spacing(-4),
    marginRight: theme.spacing(-4),
  },
}))

const InfoBox = ({ children, className }: { children: React.ReactNode; className: string }) => {
  const {
    classes: { infoBox },
    cx,
  } = useStyles()

  return <div className={cx(className, infoBox)}>{children}</div>
}

export default InfoBox
